import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-regs-two-way',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="two-way-box">
      @for (item of displayItems; track item.value) {
        <button
          type="button"
          class="two-way-btn"
          [class.two-way-btn--active]="item.value === value"
          (click)="select(item.value)"
        >
          {{ item.label }}
        </button>
      }
    </div>
  `,
  styles: [
    `
      .two-way-box {
        display: flex;
        padding: 3px;
        background: #f2f2f6;
        border-radius: 12px;
        user-select: none;
      }
      .two-way-btn {
        flex: 1;
        height: 38px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: transparent;
        border-radius: 10px;
        font-size: 15px;
        font-weight: 500;
        color: #6c6c70;
        cursor: pointer;
        transition: all 180ms ease;
      }
      .two-way-btn--active {
        background: #ffffff;
        color: #1c1c1e;
        font-weight: 600;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegsTwoWayComponent<T = any> {
  private _items: { label: string; value: T }[] = [];
  private _values?: T[];
  private _labels?: string[];

  @Input()
  set items(val: { label: string; value: T }[]) {
    this._items = val || [];
  }

  @Input()
  set values(v: T[]) {
    this._values = v;
  }

  @Input()
  set labels(l: string[]) {
    this._labels = l;
  }

  get displayItems(): { label: string; value: T }[] {
    if (this._values && this._labels) {
      return this._values.map((v, i) => ({ label: this._labels![i] ?? String(v), value: v }));
    }
    return this._items;
  }

  @Input({ required: true }) value!: T;
  @Output() valueChange = new EventEmitter<T>();

  select(val: T): void {
    if (this.value !== val) {
      this.valueChange.emit(val);
    }
  }
}
